import PositionedOverlayBase from './PositionedOverlayBase';
export default PositionedOverlayBase;